"use strict";
var Vector3_1 = require('gdx-ai/lib/math/Vector3');
var SteeringUtils3D_1 = require('./SteeringUtils3D');
var SteeringLocation3D = (function () {
    function SteeringLocation3D() {
        this.position = new Vector3_1.default();
        this.orientation = 0;
    }
    SteeringLocation3D.prototype.getPosition = function () {
        return this.position;
    };
    SteeringLocation3D.prototype.getOrientation = function () {
        return this.orientation;
    };
    SteeringLocation3D.prototype.setOrientation = function (orientation) {
        this.orientation = orientation;
    };
    SteeringLocation3D.prototype.newLocation = function () {
        return new SteeringLocation3D();
    };
    SteeringLocation3D.prototype.vectorToAngle = function (vector) {
        return SteeringUtils3D_1.vectorToAngle(vector);
    };
    SteeringLocation3D.prototype.angleToVector = function (outVector, angle) {
        return SteeringUtils3D_1.angleToVector(outVector, angle);
    };
    return SteeringLocation3D;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SteeringLocation3D;
//# sourceMappingURL=SteeringLocation3D.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/SteeringLocation3D.js
 ** module id = 927
 ** module chunks = 0
 **/